// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#title {
  line-height: 1.25;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  color: #3B71CA;
  font-weight: 600;
  padding-top: 40px;
  font-size: 1.1rem;
  margin-bottom: 25px;
}

.user-management-menu {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 20px;
}
.user-management-menu div {
  text-decoration: none;
  cursor: pointer;
  color: #ffffff;
  padding: 8px 4px;
}
.user-management-menu div:hover {
  background: #436799;
  border-radius: 5px;
  color: #ffffff;
}
.user-management-menu div:hover i {
  text-shadow: rgba(0, 0, 0, 0.2);
}
.user-management-menu i {
  margin-left: 8px;
  color: #ffffff;
}

.menu-item.active {
  background-color: #436799; /* Active tab background color */
  color: #ffffff;
  border-radius: 5px;
}
.menu-item.active i {
  color: #0080ff;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);
}`, "",{"version":3,"sources":["webpack://./src/app/features/user-management/menu/user-mangement-menu/user-mangement-menu.component.scss"],"names":[],"mappings":"AAAI;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AACR;;AAEQ;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,iBAAA;AAAR;AAEQ;EACI,qBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAAZ;AAEY;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;AAAhB;AAEgB;EAEI,+BAAA;AADpB;AAMQ;EACI,gBAAA;EACA,cAAA;AAJZ;;AASA;EACI,yBAAA,EAAA,gCAAA;EACA,cAAA;EACQ,kBAAA;AANZ;AAQY;EACI,cAAA;EACA,uCAAA;AANhB","sourcesContent":["    #title {\n        line-height: 1.25;\n        text-align: center;\n        padding-left: 15px;\n        padding-right: 15px;\n        color: #3B71CA;\n        font-weight: 600;\n        padding-top: 40px;\n        font-size: 1.1rem;\n        margin-bottom: 25px;\n    }\n\n        .user-management-menu {\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n        // font-size: 1rem;\n        padding-top: 20px;\n\n        div {\n            text-decoration: none;\n            cursor: pointer;\n            color: #ffffff;\n            padding: 8px 4px;\n\n            &:hover {\n                background: #436799;\n                border-radius: 5px;\n                color: #ffffff;\n\n                i {\n                    // color: #c2c0c0;\n                    text-shadow: #00000033;\n                }\n            }\n        }\n\n        i {\n            margin-left: 8px;\n            color: #ffffff ;\n        }\n\n    }\n\n.menu-item.active {\n    background-color: #436799; /* Active tab background color */\n    color: #ffffff;\n            border-radius: 5px;\n\n            i {\n                color: #0080ff;\n                text-shadow: 0 0 4px rgba(0, 0, 0, 0.8); // ← black glow\n            }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
